import { render, staticRenderFns } from "./ProfileSubsectionTitle.vue?vue&type=template&id=1467b05c&scoped=true"
import script from "./ProfileSubsectionTitle.vue?vue&type=script&lang=js"
export * from "./ProfileSubsectionTitle.vue?vue&type=script&lang=js"
import style0 from "./ProfileSubsectionTitle.vue?vue&type=style&index=0&id=1467b05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1467b05c",
  null
  
)

export default component.exports